import { DataType } from "@/jenesys-types/data/enums";
import { extractError } from "@/jenesys-types/errors";
import { performDataAction } from "@/services/api"; // Use the abstracted API call
import { call, put, StrictEffect, takeLatest } from "redux-saga/effects";

import {
    fetchCompanyBillingDetailsFailure,
    fetchCompanyBillingDetailsStart,
    fetchCompanyBillingDetailsSuccess,
    FetchStartAction,
} from "./companyDetails";

// Worker Saga: Performs the async fetch task using performDataAction
export function* fetchCompanyBillingDetailsSaga(
  action: FetchStartAction
): Generator<StrictEffect, void, any> {
  const { companyId } = action.payload;
  try {
    // Call the API using the abstraction layer
    const billingDetails = yield call(
      performDataAction,
      DataType.CompanyBillingDetails, // Use the new DataType
      "get", // The action name defined in api/index.ts
      { companyId } // Path parameters
    );
    // Dispatch success action with the fetched data
    yield put(fetchCompanyBillingDetailsSuccess(billingDetails));
  } catch (error) {
    // Dispatch failure action with the error
    yield put(fetchCompanyBillingDetailsFailure(extractError(error)));
  }
}

// Watcher Saga: Listens for the fetchStart action and calls the worker saga
export default function* companyDetailsSaga() {
  yield takeLatest(
    fetchCompanyBillingDetailsStart.type,
    fetchCompanyBillingDetailsSaga
  );
} 